//@flow

export const generateRandomId = () =>
  Math.random()
    .toString(36)
    .substr(3, 10);
